<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#2D3436" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br /> 
                <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text mb-3">{{ title }}</div>
                <div v-frag v-for="(examenMesa, examenMesaKey) in examenes.data" :key="examenMesaKey">
                    <v-row >
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                            <v-card elevation="0">
                                <v-card-text style="background-color: rgb(250, 250, 250) !important;" v-if="examenMesa.cantidadInscipcion > 0">
                                    Cantidad de materia disponibles :
                                    {{ examenMesa.cantidadInscipcion }}
                                </v-card-text>
                                <v-card-text v-else style="background-color: rgb(250, 250, 250) !important;">
                                    Cantidad de materia disponibles : 0
                                </v-card-text>
                            </v-card>
                            {{ examenMesa.curso.nombre }}
                            <p>{{ examenes.curso }}</p>
                        </div>

                        <ModalSubsripcionExterna :inscripcionesDisponibles="examenMesa.cantidadInscipcionAntesDescuento
                            " :montoXmateria="parseInt(examenMesa.montoXmateria)" :idMesa="parseInt(examenMesa.id)"
                            v-if="
                                examenMesa.muestraBotonTolerancia &&
                                examenMesa.cantidadInscipcionAntesDescuento
                                    .length > 0
                            " />

                        <v-btn color="primary" v-if="examenMesa.tieneDeudaGeneral"
                            @click="pagarMontoDeuda(examenMesa.id)">
                            Pagar Deuda : {{ examenMesa.montoDeudaGeneral }}
                        </v-btn>
                    </v-row>
                    <v-simple-table style="
                              margin-top: 10px;
                              margin-bottom: 30px;
                              text-align: center;
                              vertical-align: middle !important ;
                            ">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">Examen</th>
                                    <th class="text-center">
                                        Validación académica
                                    </th>
                                    <th class="text-center">Validación de pago</th>
                                    <th class="text-center">Estado</th>
                                    <th class="text-center">Acciónes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(planDeEstudioData,
                                    planDeEstudioDataKey) in examenMesa.curso
                                        .plan_de_estudio_v2" :key="planDeEstudioDataKey">
                                    <td v-if="
                                        planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    " class="td-mesa" style="
                                      border-left: 1px solid #ddd;
                                      border-bottom: 1px solid #ddd;
                                      width: 30%;
                                      text-align: left !important;
                                    ">
                                        {{ planDeEstudioData.Materia }}
                                    </td>

                                    <td v-if="
                                        planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    " class="td-mesa" style="
                                      border-bottom: 1px solid #ddd;
                                      width: 10%;
                                    ">
                                        <span v-if="
                                            planDeEstudioData.validacion_academica ==
                                            'aceptada' &&
                                            (planDeEstudioData.validacion_pago ==
                                                'aceptada' ||
                                                planDeEstudioData.validacion_pago ===
                                                null) &&
                                            planDeEstudioData.status != 0
                                        " style="color: green">&#10004;
                                        </span>
                                        <span v-else-if="
                                            planDeEstudioData.validacion_academica ==
                                            'aceptada' &&
                                            planDeEstudioData.nuevo_monto_deuda >
                                            0 &&
                                            planDeEstudioData.status != 0
                                        " style="color: green">&#10004;
                                        </span>
                                        <span v-else-if="
                                            planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                            planDeEstudioData.status != 0
                                        " style="color: red">&#10006;
                                        </span>
                                        <span v-else-if="planDeEstudioData.status == 0">
                                        </span>
                                    </td>

                                    <td v-if="
                                        planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    " class="td-mesa" style="
                                      border-bottom: 1px solid #ddd;
                                      width: 10%;
                                    ">
                                        <div v-if="
                                            planDeEstudioData.nuevo_monto_deuda > 0 &&
                                            planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                            planDeEstudioData.status != 0
                                        ">
                                            <span style="color: red">&#10006;</span>
                                        </div>
                                        <div v-else-if="
                                            btnDeshabilitadoDeuda == true &&
                                            planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                            planDeEstudioData.status != 0
                                        ">
                                            <span style="color: red">&#10006;</span>
                                        </div>
                                        <div v-else-if="
                                            planDeEstudioData.validacion_pago ==
                                            'aceptada' &&
                                            planDeEstudioData.status != 0
                                        ">
                                            <span style="color: green">&#10004;</span>
                                        </div>
                                        <div v-else-if="
                                            planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                            planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                            planDeEstudioData.nuevo_monto_deuda <=
                                            0 &&
                                            planDeEstudioData.status != 0
                                        ">
                                            <span style="color: green">&#10004;</span>
                                        </div>
                                        <div v-else-if="planDeEstudioData.status == 0"
                                            id="mostarNoData_validacion_pago">
                                            <span></span>
                                        </div>
                                    </td>

                                    <td v-if="
                                        planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    " class="td-mesa" id="td_motivo" style="
                                      border-bottom: 1px solid #ddd;
                                      width: 20%;
                                    ">
                                        <div v-if="
                                            planDeEstudioData.motivo_rechazo &&
                                            planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                            planDeEstudioData.rechazo_pago == 1 &&
                                            planDeEstudioData.status != 0
                                        ">
                                            {{ planDeEstudioData.motivo_rechazo }}
                                            <br />
                                            <!-- <a   href="javascript:void(0)" @click="pagarMontoDeuda(examenMesa.id,planDeEstudioData.IDStB,planDeEstudioData.examen_inscipcion_alumno[0].id_validacion)" class="boton-pago" style="margin-bottom: 5px;"> -->
                                            <!-- <button  class="btn-primary">Pagar ${{planDeEstudioData.nuevo_monto_deuda }}</button> -->
                                            <!-- </a> -->
                                        </div>
                                        <div v-else-if="
                                            planDeEstudioData.motivo_rechazo &&
                                            planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                            planDeEstudioData.rechazo_pago ===
                                            null &&
                                            planDeEstudioData.status != 0
                                        ">
                                            {{ planDeEstudioData.motivo_rechazo }}
                                        </div>
                                        <div v-else-if="
                                            planDeEstudioData.motivo_rechazo &&
                                            planDeEstudioData.rechazo_pago === null
                                        ">
                                            {{ planDeEstudioData.motivo_rechazo }}
                                        </div>
                                        <div v-else-if="
                                            planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                            planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                            planDeEstudioData.nuevo_monto_deuda <=
                                            0 &&
                                            planDeEstudioData.status != 0
                                        ">
                                            {{ planDeEstudioData.motivo_rechazo }}
                                        </div>
                                        <div v-else-if="planDeEstudioData.status == 0"></div>
                                    </td>

                                    <td v-if="
                                        planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    " style="
                                      vertical-align: middle !important;
                                      text-align: center;
                                      border-right: 1px solid #ddd;
                                      border-bottom: 1px solid #ddd;
                                      width: 20%;
                                    ">
                                        <div v-frag v-if="planDeEstudioData.tipo == 0">
                                            <v-btn @click="() => null" class="grey--text font-weight-regular" depressed
                                                text disabled color="grey">Sin Mesa Aún</v-btn>
                                        </div>
                                        <div v-frag v-if="planDeEstudioData.tipo == 1">
                                            <div v-frag v-if="
                                                planDeEstudioData.diasUltimaInscripcion >=
                                                550 &&
                                                planDeEstudioData.excepcion_validacion ==
                                                null
                                            ">
                                                <v-btn id="validateDays" style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " depressed text color="primary" @click="
                                            exepcionValidacion(
                                                planDeEstudioData.IDStB,
                                                examenMesa.id
                                            )
                                            ">
                                                    Solicitar Excepcion
                                                </v-btn>
                                            </div>

                                            <div v-frag v-else-if="
                                                planDeEstudioData.diasUltimaInscripcion >=
                                                550 &&
                                                planDeEstudioData.excepcion_validacion
                                                    .status == null
                                            ">
                                                <v-btn id="validateDays" style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " depressed text color="primary">
                                                    Esperando Confirmacion
                                                </v-btn>
                                            </div>

                                            <div v-frag v-else-if="
                                                planDeEstudioData.diasUltimaInscripcion >=
                                                550 &&
                                                planDeEstudioData.excepcion_validacion
                                                    .status == 0
                                            ">
                                                <v-btn id="validateDays" style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " depressed text color="red">
                                                    Excepcion Rechazada
                                                </v-btn>
                                            </div>

                                            <div v-frag v-else-if="
                                                btnDeshabilitadoDeuda == true &&
                                                planDeEstudioData.diasUltimaInscripcion <
                                                550
                                            ">
                                                <v-btn id="ins_1" style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " :disabled="true" depressed text color="Colorsuccess">
                                                    Inscribir
                                                </v-btn>
                                            </div>
                                            <div v-else>
                                                <v-btn id="ins_2" v-show="extenderPeriodo == false &&
                                                    examenes.cantidad > 0 && examenMesa.cantidadInscipcion > 0
                                                    " style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " @click="
                                            inscripcionMesaExamen(
                                                planDeEstudioData.IDStB,
                                                examenMesa.id,
                                                examenMesa.cantidadInscipcion
                                            )
                                            " depressed text color="Colorsuccess">Inscribir</v-btn>
                                                <v-btn id="ins_0" v-show="examenMesa.cantidadInscipcion == 0
                                                    " style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " disabled depressed text color="default">Sin cupo</v-btn>

                                                <v-btn v-show="user.ext_mesas > 0" style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " @click="
                                            inscripcionMesaExamen(
                                                planDeEstudioData.IDStB,
                                                examenMesa.id
                                            )
                                            " depressed text color="Colorsuccess">Inscribir</v-btn>

                                                <v-btn id="ins_3" v-show="planDeEstudioData.status == 0" style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          " @click="
                                            inscripcionMesaExamen(
                                                planDeEstudioData.IDStB,
                                                examenMesa.id
                                            )
                                            " depressed text color="Colorsuccess">Inscribir</v-btn>
                                            </div>
                                        </div>
                                        <div v-frag v-if="
                                            planDeEstudioData.tipo == 2 &&
                                            planDeEstudioData.status != 0
                                        ">
                                            <v-alert color="info" style="
                                          background-color: rgba(
                                            100,
                                            181,
                                            246,
                                            0.2
                                          ) !important;
                                          border: 1px solid;
                                          padding: 5px;
                                          margin-bottom: 5px !important;
                                          margin-top: 5px !important;
                                          padding-left: 0px;
                                          padding-right: 0px;
                                        ">
                                                Esperando confirmación
                                                <v-btn v-if="
                                                    esFechaMenorOIgual(
                                                        examenMesa.fechaTolerancia
                                                    )
                                                " @click="
                                                    cancelarInscripcionMesaExamen(
                                                        planDeEstudioData
                                                            .examen_inscipcion_alumno[0]
                                                            .id_validacion
                                                    )
                                                    " small
                                                    class="red--text text-decoration-underline font-weight-regular"
                                                    depressed text color="red">Cancelar</v-btn>
                                            </v-alert>
                                        </div>
                                        <div v-frag v-if="planDeEstudioData.tipo == 3">
                                            <div v-if="planDeEstudioData != null">
                                                <div v-if="
                                                    planDeEstudioData.examen_asociado !=
                                                    null &&
                                                    planDeEstudioData.examen_asociado
                                                        .tipo_link == 0
                                                ">
                                                    <v-btn @click="
                                                        linkPrueba(
                                                            planDeEstudioData.examen_asociado
                                                                .id_testpyr
                                                        )
                                                        " depressed style="
                                              border: 1px solid;
                                              padding-left: 33px;
                                              padding-right: 33px;
                                            " text color="rgb(143, 198, 220)">
                                                        Prueba
                                                    </v-btn>
                                                </div>

                                                <div v-else-if="
                                                    planDeEstudioData.examen_asociado !=
                                                    null
                                                ">
                                                    <v-btn :href="planDeEstudioData.examen_asociado
                                                        .google_meet_url
                                                        " depressed target="_blank" style="
                                              border: 1px solid;
                                              margin-left: 10px;
                                            " text color="rgb(219, 29, 74)">
                                                        ClassRoom
                                                    </v-btn>
                                                </div>

                                                <div v-else>
                                                    <v-alert color="Colorsuccess" dense style="
                                              color: white;
                                              padding: 5px 0px;
                                              margin-bottom: 5px !important;
                                              margin-top: 5px !important;
                                              display: inline-block;
                                              padding-left: 24px;
                                              padding-right: 25px;
                                            ">
                                                        Inscripto
                                                    </v-alert>
                                                </div>
                                            </div>

                                            <div v-else>
                                                <v-btn @click="() => null" class="grey--text font-weight-regular"
                                                    depressed text disabled color="grey">
                                                    Sin Mesa Aún
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div v-if="
                                            btnDeshabilitadoDeuda == false &&
                                            planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                            (planDeEstudioData.validacion_academica ==
                                                'aceptada' ||
                                                planDeEstudioData.validacion_academica ===
                                                null) &&
                                            planDeEstudioData.tipo != 4
                                        ">
                                            <v-btn id="ins_4" v-show="examenes.cantidad > 0" style="
                                          border: 1px solid;
                                          padding-left: 24px;
                                          padding-right: 25px;
                                        " @click="
                                            inscripcionMesaExamen(
                                                planDeEstudioData.IDStB,
                                                examenMesa.id
                                            )
                                            " depressed text color="Colorsuccess">Inscribir</v-btn>
                                        </div>
                                        <div class="" v-if="
                                            planDeEstudioData.status == 0 &&
                                            planDeEstudioData.tipo == null
                                        ">
                                            <v-btn v-show="examenes.cantidad > 0"
                                                style="border: 1px solid; padding-left: 24px; padding-right: 25px;"
                                                @click="
                                                    inscripcionMesaExamen(
                                                        planDeEstudioData.IDStB,
                                                        examenMesa.id
                                                    )
                                                    " depressed text color="Colorsuccess">Inscribir</v-btn>
                                        </div>
                                        <div v-frag v-else-if="planDeEstudioData.tipo == 4">
                                            <v-alert color="error" style="
                                          color: white;
                                          padding: 5px 0px;
                                          margin-bottom: 5px !important;
                                          margin-top: 5px !important;
                                          display: inline-block;
                                          padding-left: 24px;
                                          padding-right: 25px;
                                        ">
                                                Rechazado
                                            </v-alert>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-col>
        </CardIeaAppMain>
    </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalSubsripcionExterna from "../../components/ModalSubsripcionExterna.vue"
export default {
    name: "InscripcionExamen",
    components: {
        CardIeaAppMain,
        ModalSubsripcionExterna
    },
    data() {
        return {
            title: "Tus Inscripciones a Exámenes",
            examenes: [],
            inscripcionesDisponibles: [],
            btnDeshabilitadoDeuda: false,
            extenderPeriodo: false,
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        async inscripcionMesaExamen(examen, mesa, cantidadInscripcion) {
            await this.$API
                .post({
                    url: "examen/mesas-inscripcion-new",
                    data: {
                        materia_id: examen,
                        examenMesa_id: mesa,
                        cantidadInscripcion: cantidadInscripcion
                    }
                })
                .then(() => {
                    this.mesaDeExamen();
                });
        },
        async cancelarInscripcionMesaExamen(id) {
            await this.$API
                .post({
                    url: "examen/cancelar-inscripcion",
                    data: {
                        id: id
                    }
                })
                .then(() => {
                    this.mesaDeExamen();
                });
        },
        async pagarMontoDeuda(id_mesa) {
            console.log(id_mesa);
            let dataSend = {
                // id_inscripcion:id_inscripcion,
                id_mesa: id_mesa,
                alumno: this.user.IDStB
                // id_validacion:id_validacion
            };

            let url = "mobbex/mobbex-pago-deuda-examen";
            this.$API
                .post({
                    url: url,
                    data: dataSend
                })
                .then(res => {
                    location.href = res.data.url;
                });
        },
        async exepcionValidacion(materia, mesa) {
            await this.$API
                .post({
                    url: "exepcion-validacion-inscripcion",
                    data: {
                        materia_id: materia,
                        mesa_id: mesa
                    }
                })
                .then((res) => {
                    console.log(res)
                    this.mesaDeExamen();
                });
        },
        esFechaMenorOIgual(fecha) {
            const fechaTolerancia = new Date(fecha);
            const fechaActual = new Date();
            return fechaTolerancia >= fechaActual;
        },
        linkPrueba(idPrueba) {
            this.$router.push({
                name: "examen",
                params: {
                    test: idPrueba
                }
            });
        },
        async mesaDeExamen() {
            await this.$API
                .get({
                    url: "examen/mesas",
                    data: {}
                })
                .then(res => {
                    for (let index = 1; index <= res.cantidad; index++) {
                        this.inscripcionesDisponibles.push(index);
                    }
                    this.examenes = res;

                    this.btnDeshabilitadoDeuda = res.data.some(curso => {
                        const materias = Object.values(curso.curso.plan_de_estudio_v2);
                        return materias.some(materia => materia.rechazo_pago === 1);
                    });
                });
        },
    },
    mounted() {
        this.mesaDeExamen()
    },
}
</script>